import { render, staticRenderFns } from "./CuponPage.vue?vue&type=template&id=64feb53e&"
import script from "./CuponPage.vue?vue&type=script&lang=js&"
export * from "./CuponPage.vue?vue&type=script&lang=js&"
import style0 from "./CuponPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CuponPage.vue"
export default component.exports